import React from "react";
import Close from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

import { ICON_MAP } from "../common.constants.js";

import "./slideMenu.scss";

import routes from "../../../assets/data/routes.json";

const SlideMenu = ({ closeSlideMenu }) => {
    const navigate = useNavigate();

    return (
        <div className="slideMenu flexContainer flexCol">
            <div className="slideMenuHeader flexContainer">
                <div className="closeSlideMenuContainer">
                    <Close
                        className="closeSlideMenuAction"
                        fontSize="medium"
                        onClick={() => closeSlideMenu()}
                    />
                </div>
            </div>
            <div className="flexGrow flexContainer flexCol centerAlign slideMenuOptionContainer">
                {routes.map(({ route, label, icon, id }) => {
                    return (
                        <div
                            className="flexContainer centerAlign slideMenuOption"
                            key={id}
                            onClick={() => {
                                navigate(route);
                                closeSlideMenu();
                            }}
                        >
                            {ICON_MAP[icon]}
                            {label}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SlideMenu;
